import { Component, Input, OnInit, inject } from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";
import { TranslateService } from "@ngx-translate/core";
import { LoginService } from "../login/login.service";
import { LocalStorageService, UserLocalStorageObject } from "../shared/local-storage.service";
import { SharedService } from "../shared/shared.service";
import { ChatbotService } from "../shared/chatbot.service";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import moment from "moment";
import { AppConfig, AppConfigType } from "../shared/models/appConfig.model";
import { CldrIntlService, IntlService } from "@progress/kendo-angular-intl";

@Component({
    selector: "app-toolbar",
    templateUrl: "./toolbar.component.html",
    styleUrls: ["./toolbar.component.scss"],
    standalone: false,
})
export class ToolbarComponent implements OnInit {
    @Input() sidenav: MatSidenav;
    @Input() loginComponent: boolean;

    public sessionExist = false;
    public currentFormatedDate = moment().format("YYYY-MM-DD");
    public showPilotHourLimits = false;

    public userSession: UserLocalStorageObject;

    // public isCamoUser = false;
    public passengersConfig: AppConfig;
    public dailyCheckConfig: AppConfig;
    public isRouteAI = false;

    protected readonly chatbotService = inject(ChatbotService);

    protected translateService = inject(TranslateService);
    private _sharedService = inject(SharedService);
    private _loginService = inject(LoginService);
    private _localStorageService = inject(LocalStorageService);
    private router = inject(Router);
    private intlService = inject(IntlService);

    constructor() {
        this.userSession = this._localStorageService.getUserLocalStorageObject();
        this.showPilotHourLimits = this.userSession.showPilotHourLimits;
        this.sessionExist = this._localStorageService.userLocalStorageExist();
        this._loginService.userData.subscribe((result) => {
            if (result) {
                this.sessionExist = this._localStorageService.userLocalStorageExist();
            } else {
                this.sessionExist = false;
            }
        });
    }

    ngOnInit(): void {
        // console.log(this._localStorageService.getUserLocalStorageObject());
        // if (this._localStorageService.getUserLocalStorageObject().htlAccountTypes.length > 0) {
        //   this.isCamoUser = true;
        // }
        this.passengersConfig = this._localStorageService.getUserLocalStorageObject().appConfigs.find((config) => config.type === AppConfigType.passengers);
        this.dailyCheckConfig = this._localStorageService.getUserLocalStorageObject().appConfigs.find((config) => config.type === AppConfigType.dailyCheck);
        this.isRouteAI = this.router.url.split("?")[0] === "/ai";
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: any) => {
            this.isRouteAI = event.urlAfterRedirects.split("?")[0] === "/ai";
        });
    }

    changeLanguageClick(lang: string) {
        (this.intlService as CldrIntlService).localeId = lang;
        this.translateService.use(lang);
        // localStorage.setItem(environment.appSessionUniqueId, JSON.stringify({ 'lang': lang }));
        this._localStorageService.setAppLocalStorage("lang", lang);
    }

    emitSidenavToggle() {
        this._sharedService.sidenavToggle.emit();
    }

    doUserLogout() {
        this.sessionExist = false;
        this._loginService.logout();
    }

    viewProfile() {
        this.router.navigate(["/profile"]);
    }
}
